import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getSessionUserData } from '../states/session-user/session-user.selectors';
import { Subject, takeUntil } from 'rxjs';
import { sessionUserData } from '../interfaces/states-data';
// import { UisrAuthService } from '../services/uisr-auth.service';

@Directive({ selector: '[appGlobalValidateAccessExperience]' })
export class GlobalValidateAccessExperienceDirective {

  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  sessionUserState: sessionUserData = {};


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<any>,
    // private authService: UisrAuthService
  ) {

    // Al recibir cambios del reducer - User
    this.store.pipe(select(getSessionUserData), takeUntil(this.ngUnsubscribe)).subscribe((data: sessionUserData) => {

      // Se guarda en local storage el estado obtenido
      localStorage.setItem('sessionUserState', JSON.stringify(data));

      // Se guarda en el componente local el estado obtenido
      this.sessionUserState = data;


    });

  }

  @Input()
  set appGlobalValidateAccessExperience(action: string[] | null | undefined) {
    // console.log(action)
    const requiredActions = this.sessionUserState.permissions_experience?.split(','); // Añade aquí las acciones que necesitas validar

    if (action && requiredActions?.some(reqAction => action.includes(reqAction))) {
      // if (true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
